<template>
  <div>
    <ul class="nav nav-mobile-menu">
      <li>
        <drop-down>
          <a slot="title" class="dropdown-toggle" data-toggle="dropdown">
            <i class="material-icons">language</i>
            <p>{{ $t("sidebar.language") }}</p>
          </a>
          <ul class="dropdown-menu dropdown-menu-right">
            <li v-for="(lang, index) in languages" :key="index">
              <a
                href="#"
                @click="changeLanguage(lang.value)"
                :class="{ 'active-language': lang.value === $i18n.locale }"
              >
                {{ lang.label }}
              </a>
            </li>
          </ul>
        </drop-down>
      </li>
      <li @click="toggleSidebar">
        <router-link :to="{ name: notificationPage }">
          <i class="material-icons">notifications</i>
          <span class="notification">{{ totalNotify }}</span>
          <p>{{ $t("common.notification") }}</p>
        </router-link>
      </li>
    </ul>
    <div
      class="user nav-mobile-menu pt-2"
      v-if="hasValidRole(role, Role.Family)"
    >
      <div class="photo">
        <i class="fas fa-users-cog text-xl icon-color-sidebar"></i>
      </div>
      <div class="user-info">
        <a
          data-toggle="collapse"
          :aria-expanded="isClosed"
          @click.stop="toggleMenu"
          @click.capture="clicked"
        >
          <span class="select-none">
            {{ $t("sidebar.switch_children") }} <b class="caret"></b>
          </span>
        </a>
        <collapse-transition>
          <div v-show="isClosed">
            <ul class="nav">
              <li
                v-for="(child, index) in accChildren"
                :key="child.username + index"
              >
                <a
                  href="#"
                  @click="switchAccountChild(child)"
                  :class="{
                    'active-language': child.username === currentChild.username
                  }"
                >
                  <span class="sidebar-normal">{{ child.full_name }}</span>
                </a>
              </li>
            </ul>
          </div>
        </collapse-transition>
      </div>
    </div>
  </div>
</template>
<script>
import { notification_names, dashboard_router_name } from "@/routes/routes";
import { mapActions, mapGetters, mapState } from "vuex";
import { getId } from "@/helpers/utils";
import Role from "@/constants/Role";
import { hasValidRole } from "@/helpers/role-helper";
import { CollapseTransition } from "vue2-transitions";
export default {
  data() {
    return {
      notificationPage: notification_names.listPage,
      languages: [
        {
          label: "English",
          value: "en"
        },
        {
          label: "Tiếng Việt",
          value: "vi"
        }
      ],
      hasValidRole,
      Role,
      isClosed: false
    };
  },
  components: {
    CollapseTransition
  },
  computed: {
    ...mapGetters("fcm", ["totalNotify"]),
    ...mapGetters("user", ["info", "role"]),
    ...mapState("switchAccountChild", ["currentChild", "accChildren"])
  },
  methods: {
    ...mapActions("fcm", ["FetchTotalNotify"]),
    ...mapActions("switchAccountChild", ["setCurrentChild"]),
    ...mapActions("switchLanguage", ["switchLanguage"]),
    toggleMenu: function() {
      this.isClosed = !this.isClosed;
    },
    clicked: function(e) {
      e.preventDefault();
    },
    switchAccountChild(child) {
      const switchChild = this.accChildren.find(
        student => student.username === child.username
      );
      if (switchChild) {
        this.setCurrentChild(switchChild);
        if (this.$route.name !== dashboard_router_name) {
          this.$router.push({ name: dashboard_router_name });
        }
      }
      this.toggleSidebar();
    },
    changeLanguage(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem("language", lang);
      this.switchLanguage(lang);
      this.toggleSidebar();
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  },
  created() {
    this.FetchTotalNotify(getId(this.info));
  }
};
</script>
<style lang="scss">
.icon-color-sidebar {
  color: #dbdadb !important;
}
.active-language {
  background-color: #4caf50;
}
</style>
